<script lang="ts">
    export let currentStep = 0
    export let stepsCount = 0
    export let solved = false
    export let correct = false
    export let error = false
    export let waitingForInit = 0
</script>

<div class="cryptcha">
    {#if error}
        <span class="error">✗</span> Fehler
    {:else if solved && correct}
        <span class="ok">✓</span> Anti-Spam-Prüfung abgeschlossen
    {:else if solved && !correct}
        <span class="error">✗</span> Ups, da ist was schief gelaufen.
    {:else if !stepsCount}
        Anti-Spam-Prüfung, bitte warten...
        <div class="waiter-bar" data-waiting="{waitingForInit}"></div>
    {:else}
        Anti-Spam-Prüfung, bitte warten<!-- ({currentStep + 1}/{stepsCount}) -->...
        <div class="progress-bar" style="width: {(currentStep / stepsCount) * 100}%"></div>
    {/if}
</div>

<style>
    div.cryptcha {
        padding-top: 10px;
        padding-bottom: 10px;
        color: #777;
        font-size: 0.8em;
    }

    div.progress-bar {
        height: 3px;
        border-radius: 3px;
        background-color: #777;
        transition: width 1.5s linear;
    }

    @keyframes waiter {
        0% {
            background: rgb(119, 119, 119);
        }
        50% {
            background: rgb(255, 255, 255);
            margin-left: 20%;
            margin-right: 20%;
        }
        100% {
            background: rgb(119, 119, 119);
        }
    }

    div.waiter-bar {
        height: 3px;
        border-radius: 3px;
        animation: waiter 2s infinite;
    }

    span.error {
        color: red;
    }

    span.ok {
        color: green;
    }
</style>
